import * as toastManagerEventBuses from "OK/ToastManagerEventBuses";
import { INIT } from "OK/ToastManagerEventBuses";
import type { IToast } from "@ok/interfaces/toast/ToastTypes";

let toasts: IToast[] = [];
let isActivated = false;

export const activate = (): void => {
    INIT.on(() => {
        if (isActivated) {
            return;
        }
        isActivated = true;
        if (toasts.length > 0) {
            toastManagerEventBuses.PUSH_TOASTS.emit({
                toasts: [...toasts]
            }, this);
        }
        toasts.length = 0;
    }, null);
};

export const registerToast = (toast: IToast): void => {
    if (isActivated) {
        toastManagerEventBuses.SHOW.emit({ toast }, this);
    } else {
        toasts.push(toast);
    }
};
